/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, Jan 2022
 * @flow
 */

import React from 'react';
import { useSelector } from 'react-redux';
import Cubby from '../Cubby';
import Header from '../Header';
import classes from './Body.module.css';

const Body = props => {
  const {
    goBack,
    showPopup,
    onSlotActionButtonPress,
    twoDimensionSlot,
    parentRoute,
    deviceGroup,
    checkList,
    onSlotAssign,
    checksForAssignment,
    onSelectCheckForAssignment,
    isPickedUpUndoEnabled,
    undoPickedUp,
    sortByName,
    ascending,
    onToggleSwitch,
    checkSortFunc,
    onShowCheckDetails,
    showClosedChecks,
    onToggleSearchInput,
    showSearch,
    onSearch,
  } = props;
  const showBack = parentRoute === 'fireboard';

  const storeInfo = useSelector(state => state.storeInfo);
  const { storeCubby } = storeInfo?.data || {};

  const isSlotAvailable = () => {
    const { slots } = storeCubby || {};
    if (slots && Array.isArray(slots) && slots.length > 0) {
      return true;
    }
    return false;
  };

  return (
    <div className={classes.bodyContainer}>
      <Header
        goBack={goBack}
        showBack={showBack}
        isPickedUpUndoEnabled={isPickedUpUndoEnabled}
        undoPickedUp={undoPickedUp}
        sortByName={sortByName}
        ascending={ascending}
        showClosedChecks={showClosedChecks}
        onToggleSwitch={onToggleSwitch}
        onToggleSearchInput={onToggleSearchInput}
      />
      {isSlotAvailable() && (
        <Cubby
          showPopup={showPopup}
          onSlotActionButtonPress={onSlotActionButtonPress}
          twoDimensionSlot={twoDimensionSlot}
          deviceGroup={deviceGroup}
          checkList={checkList}
          onSlotAssign={onSlotAssign}
          checksForAssignment={checksForAssignment}
          onSelectCheckForAssignment={onSelectCheckForAssignment}
          ascending={ascending}
          checkSortFunc={checkSortFunc}
          onShowCheckDetails={onShowCheckDetails}
          showSearch={showSearch}
          onToggleSearchInput={onToggleSearchInput}
          onSearch={onSearch}
        />
      )}
      {!isSlotAvailable() && (
        <div className={classes.noCubbyText}>No cubby found!!!</div>
      )}
    </div>
  );
}

export default Body;
